import Colors from '@/config/Colors'

export default {
  computed: {
    //
  },
  created() {
    //
  },
  methods: {  
    getColor(color) {
      if(color)
        return Colors[color] 
      else return 'black'
    },
    getHalfColor(color) {
      return Colors['half_'+ color] 
    },
    getColorByRef(ref, _color){
      // const color = _color ? _color : this.user_color
      const color = _color 
      return Colors['panel'][color][ref]
    },    
    // getFieldByTheme(theme) {
    //   return this.themes[theme].field
    // },
    // killTwn() {
    //   if(this.$twn)
    //     this.$twn.kill()
    // },
    // getHours() {
    //   const h = new Date().getUTCHours()
    //   return h+(2-h%2)
    // },
    // getOpponent(arg) {
    //   return arg == 'home' ? 'away' : 'home'
    // },
    // pressTitle() {
    //   this.$store.commit('game/USE_NAVIGATION', true)
    // },
    // isDouble() {
    //   return this.game_status.dices['home'] == this.game_status.dices['away']
    // },
  }
}


